// extracted by css-extract-rspack-plugin
export default {"button":"GoSdU","button_portal":"E7N8T","buttonPortal":"E7N8T","button_icon":"MXMdf","buttonIcon":"MXMdf","chevron_icon":"SELeQ","chevronIcon":"SELeQ"};